// Delegated event handlers that replace inline on* attributes, so the page can
// run under a strict script-src CSP (no 'unsafe-inline'). Behaviour-preserving.
//
//   onsubmit="return confirm(msg)"   -> <form data-confirm="msg"> (or on the submit button)
//   onclick="return confirm(msg)"    -> <a data-confirm="msg">
//   onchange="this.form.submit()"    -> data-autosubmit
//   onsubmit="return false"          -> data-prevent-submit
//   onclick="navigator.clipboard..." -> data-copy-target="elementId"
//   onclick="el.value=''"            -> data-clear-value="elementId"
//   onclick="someGlobal(arg)"        -> data-action="someGlobal" [data-action-arg="arg"]

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-confirm]');
  if (link && !window.confirm(link.dataset.confirm)) {
    event.preventDefault();
    return;
  }

  const copy = event.target.closest('[data-copy-target]');
  if (copy) {
    const target = document.getElementById(copy.dataset.copyTarget);
    const text = target ? (target.value ?? target.textContent ?? '') : '';
    navigator.clipboard?.writeText(text);
  }

  const clear = event.target.closest('[data-clear-value]');
  if (clear) {
    const target = document.getElementById(clear.dataset.clearValue);
    if (target) {
      target.value = '';
    }
  }

  const action = event.target.closest('[data-action]');
  if (action) {
    const fn = window[action.dataset.action];
    if (typeof fn === 'function') {
      fn(action.dataset.actionArg);
    }
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (form.matches('[data-prevent-submit]')) {
    event.preventDefault();
    return;
  }

  const message = form.getAttribute('data-confirm') ?? event.submitter?.getAttribute('data-confirm');
  if (message && !window.confirm(message)) {
    event.preventDefault();
  }
});

document.addEventListener('change', (event) => {
  const el = event.target.closest('[data-autosubmit]');
  if (el?.form) {
    el.form.submit();
  }
});
